import { render, staticRenderFns } from "./alert_command.vue?vue&type=template&id=1321e264&scoped=true&"
import script from "./alert_command.vue?vue&type=script&lang=js&"
export * from "./alert_command.vue?vue&type=script&lang=js&"
import style0 from "./alert_command.vue?vue&type=style&index=0&id=1321e264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1321e264",
  null
  
)

export default component.exports